const FETCH_USER = 'userDetail/FETCH_USER';

const FETCH_USER_STORIES = 'userDetail/FETCH_USER_STORIES';

const FOLLOW_USER = 'userDetail/FOLLOW_USER';

const FETCH_USER_FOLLOWERS = 'userDetail/FETCH_USER_FOLLOWERS';

const FETCH_USER_FOLLOWINGS = 'userDetail/FETCH_USER_FOLLOWINGS';

const FETCH_USER_COMMUNITY_POSTS = 'userDetail/FETCH_USER_COMMUNITY_POSTS';

const LIKE_COMMUNITY_POST = 'userDetail/LIKE_COMMUNITY_POST';

const RESET = 'userDetail/RESET';

const RESET_COMMUNITY_POSTS = 'userDetail/RESET_COMMUNITY_POSTS';

const RESET_FOLLOW = 'userDetail/RESET_FOLLOW';

const TOGGLE_BLOCK_USER = 'userDetail/TOGGLE_BLOCK_USER';

const U2U_ACTIVITIES = 'userDetail/U2U_ACTIVITIES';

const FETCH_USER_RESTRICTION = 'userDetail/FETCH_USER_RESTRICTION';

export default {
  FETCH_USER,
  FETCH_USER_STORIES,
  FOLLOW_USER,
  FETCH_USER_FOLLOWERS,
  FETCH_USER_FOLLOWINGS,
  FETCH_USER_COMMUNITY_POSTS,
  LIKE_COMMUNITY_POST,
  RESET,
  RESET_COMMUNITY_POSTS,
  RESET_FOLLOW,
  TOGGLE_BLOCK_USER,
  U2U_ACTIVITIES,
  FETCH_USER_RESTRICTION,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/userDetail/types.js